export const getTextByWaringValue = (maxValue: number) => {
	if (maxValue >= 4) return "extreme";
	if (maxValue === 3) return "severe";
	if (maxValue === 2) return "moderate";

	return "no_alert";
};
